import React from 'react'
import { ArticleLoader, ArticlesCategoriesLoader } from 'loaders'
import PropTypes from 'prop-types'
import ArticleEditContainer from './ArticleEditContainer'

const ArticleEdit = ({
  history,
  match: {
    params: { articleId },
  },
  match,
  location,
}) => (
  <ArticlesCategoriesLoader alwaysRenderChildren passIsLoading>
    <ArticleLoader articleId={articleId}>
      <ArticleEditContainer
        history={history}
        match={match}
        location={location}
      />
    </ArticleLoader>
  </ArticlesCategoriesLoader>
)

ArticleEdit.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.objectOf(PropTypes.string).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
}

export default ArticleEdit
